import TYSHero from '../components/tys-parallax-hero';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import Popup from '../components/Popup';
import { Link } from 'react-router-dom';
import PrimaryButton from '../components/PrimaryButton';

function TheYoungSamaritan() {
  const location = useLocation();

  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <TYSHero key={location.key} />
      <div className='tys-book-page-wrapper'>
        <div className='container-large' id='scroll'>
          <div className='get-a-copy'>
            <div className='gac-grid'>
              <div className='book-info'>
                <div className='get-a-copy__header'>
                  <p className='get-a-copy__eyebrow'>Available now</p>
                  <h2>Get the Book</h2>
                  <p className='get-a-copy__intro'>
                    Pick up the debut novel and step into Joshua&apos;s journey
                    through ancient Samaria, faith, exile, and belonging.
                  </p>
                </div>
                <div className='book-title'>
                  <h4 className='title sans-serif'>The Young Samaritan</h4>
                  <p>by J. Schuyler Sprowles</p>
                </div>
                <p className='book-mini-sum'>
                  Joshua, a Samaritan teenager in ancient Samaria, embarks on a
                  life-changing journey amidst Jesus' early followers. Joshua
                  faces adversities and discoveries that shape his path to
                  maturity and faith. Set in historical biblical times, the
                  story vividly portrays Jesus' impact through Joshua's eyes,
                  appealing to both young and adult readers, believers and
                  non-believers alike.
                </p>
                <div className='purchase-buttons'>
                  <PrimaryButton
                    as='a'
                    href='https://a.co/d/dX1kChy'
                    label='Amazon'
                    tone='light'
                    icon={
                      <img
                        className='icon'
                        src={process.env.PUBLIC_URL + '/images/amazon.svg'}
                        alt=''
                      />
                    }
                  />
                  <PrimaryButton
                    as='a'
                    href='https://store.bookbaby.com/book/the-young-samaritan'
                    label='BookBaby'
                    tone='light'
                    icon={
                      <img
                        className='icon'
                        src={process.env.PUBLIC_URL + '/images/bookbaby.svg'}
                        alt=''
                      />
                    }
                  />
                </div>
                <div className='publish-info'>
                  <div className='publish-info__item'>
                    <span className='publish-info__label'>Publisher</span>
                    <span>BookBaby</span>
                  </div>
                  <div className='publish-info__item'>
                    <span className='publish-info__label'>Publish date</span>
                    <span>February 16, 2024</span>
                  </div>
                </div>
              </div>
              <div
                className='book-cover'
                onMouseEnter={() => setIsHovered(true)}
                onClick={() => setIsHovered(false)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <div className='book-cover__frame'>
                  <Popup
                    trigger={
                      <img
                        src={process.env.PUBLIC_URL + '/images/book1.png'}
                        alt='The Young Samaritan Book Cover'
                        className='clickable-image book'
                      />
                    }
                  >
                    <img
                      src={process.env.PUBLIC_URL + '/images/tys-full-cover.jpg'}
                      alt='The Young Samaritan Full Book Cover'
                    />
                  </Popup>
                  {isHovered && (
                    <div className='hover-text'>View Full Cover</div>
                  )}
                </div>
                <p className='book-cover__note'>
                  Tap the cover to open the full jacket.
                </p>
              </div>
            </div>
          </div>

          <section className='testimonials-preview'>
            <div className='testimonials-preview__header'>
              <p className='testimonials-preview__eyebrow'>Early praise</p>
              <h2>What people are saying</h2>
              <p className='testimonials-preview__intro'>
                A few early responses from pastors, leaders, and readers who
                connected with Joshua&apos;s story.
              </p>
            </div>
            <div className='grid quotes'>
              <div className='grid-item quote-art quote-art--one'>
                <div></div>
              </div>
              <article className='grid-item quote-card'>
                <blockquote className='quote animate-text'>
                  <span className='big-quote'>“</span>In this inspiring journey
                  across the ancient landscapes of the gospels, Schuyler tells
                  the untold tale of a resilient boy who, when others faltered,
                  stood steadfastly by Jesus, showcasing the unwavering power
                  of youthful courage, unyielding belief, and the enduring bond
                  that transcends time.”
                </blockquote>
                <p className='quote-title'>
                  MATHEW P. JOHN
                  <span>Senior Pastor, Lake Avenue Church, Pasadena, CA</span>
                </p>
              </article>
              <article className='grid-item quote-card'>
                <blockquote className='quote animate-text'>
                  <span className='big-quote'>“</span>Get ready to encounter the
                  people and places of the Ancient Near East through the eyes
                  of Joshua, whose story will make you laugh, cry, and reflect
                  on your own journey to love and be loved. Readers of all ages
                  will be charmed as Sprowles draws upon the Gospel of Mark for
                  the backdrop of this heartwarming coming-of-age tale.”
                </blockquote>
                <p className='quote-title'>
                  LISA HALLER LIOU
                  <span>
                    Former Regional Director, Inter Varsity Christian
                    Fellowship/USA
                  </span>
                </p>
              </article>
              <div className='grid-item quote-art quote-art--two'>
                <div></div>
              </div>
            </div>
            <div className='testimonials-preview__footer'>
              <PrimaryButton
                as={Link}
                to='/writing/the-young-samaritan/reviews'
                label='More Reviews'
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default TheYoungSamaritan;
